export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4010cb5eece30c499c2bb713506a4ce98ac33cd48e&name=revalidateCommunity!'